import { Text } from "@ucl/react-library";
import { useTranslation } from "react-i18next";
import { ContactPreference } from "src/api/types/enums";

export const ContactExplanation = ({ contactType }: { contactType?: ContactPreference; }) => {
  const { t } = useTranslation();
  let paragraphs = t("contactInfo.genericParas", { returnObjects: true });
  switch (contactType) {
    case ContactPreference.Email:
      paragraphs = t("contactInfo.emailParas", { returnObjects: true });
      break;
    case ContactPreference.Post:
      paragraphs = t("contactInfo.postParas", { returnObjects: true });
      break;
  }

  return (
    <div className="flex flex-col gap-3" data-testid="currentContactPreference" >
      <Text.P size="large" fontWeight="semi-bold">
        {t("contactInfo.title")}
      </Text.P>
      {Array.isArray(paragraphs) && paragraphs.map(para => (
        <Text.P size="large" key={para} >{para}</Text.P>
      ))}
    </div>
  );
};
